<template>
  <div>
    <div>
      <el-form :disabled="!isOk" :inline="true" ref="form2">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="name" label="书名" width="200" show-overflow-tooltip/>
        <el-table-column prop="author" label="作者" width="150" show-overflow-tooltip/>
        <el-table-column prop="publish" label="出版社" width="150" show-overflow-tooltip/>
        <el-table-column prop="buy" label="价格" width="100"/>
        <el-table-column prop="day" label="购买日期" width="120"/>
        <el-table-column prop="remark" label="备注" width="200" show-overflow-tooltip/>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleSet(scope.row)" size="small">修改</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="书名" prop="name" :rules="[{required: true, message: '书名为空'}]">
          <el-input v-model="form.name" maxlength="200" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="author" :rules="[{required: true, message: '作者为空'}]">
          <el-input v-model="form.author" maxlength="200" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="出版社" prop="publish" :rules="[{required: true, message: '出版社为空'}]">
          <el-input v-model="form.publish" maxlength="200" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="buy" type="number" :rules="[{required: true, message: '价格为空'}]">
          <el-input v-model="form.buy" maxlength="50" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="购买日期" prop="day" :rules="[{required: true, message: '购买日期为空'}]">
          <el-date-picker v-model="form.day" type="date" value-format="yyyy-MM-dd" placeholder="购买日期" style="width: 280px"/>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" maxlength="200" style="width: 280px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取消</el-button>
        <el-button type="primary" v-if="dialogStatus==='add'" @click="add('form')"><span>确定</span></el-button>
        <el-button type="primary" v-if="dialogStatus==='set'" @click="set('form')"><span>确定</span></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as http from '../api/http'
import * as util from '../util/util'
import global from '../components/Global'

export default {
  name: 'Library',
  data () {
    return {
      isOk: false,
      dialogStatus: '',
      dialogTitle: '',
      dialogVisible: false,
      param: {},
      tableData: [],
      form: {}
    }
  },
  created () {
    if (global.uid <= 0 || global.token === '') {
      this.$router.push('/')
      return
    }
    this.list()
  },
  methods: {
    cancel () {
      this.dialogVisible = false
    },
    add (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.id = 0
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        http.post(global.url0 + 'nsy-library/add/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('新增成功')
              this.list()
            } else {
              this.$message.error('新增失败:' + res)
            }
          }
        )
      })
    },
    set (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        http.post(global.url0 + 'nsy-library/set/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('修改成功')
              this.list()
            } else {
              this.$message.error('修改失败:' + res)
            }
          }
        )
      })
    },
    handleAdd () {
      this.form = {}
      this.dialogStatus = 'add'
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },
    handleSet (row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogStatus = 'set'
      this.dialogTitle = '修改'
      this.dialogVisible = true
    },
    handleDel (row) {
      this.$confirm('此操作将永久删除记录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = {}
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        this.form.id = row.id
        http.post(global.url0 + 'nsy-library/del/', this.form).then(
          res => {
            if (res === 200) {
              this.$message.success('删除成功')
              this.list()
            } else {
              this.$message.error('删除失败')
            }
          }
        )
      })
    },
    list () {
      this.isOk = false
      this.tableData = []
      this.param.uid = global.uid
      this.param.token = global.token

      http.post(global.url0 + 'nsy-library/list/', this.param).then(
        res => {
          let resStr = res.data.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          let arr = res.data
          for (let i = 0; i < arr.length; i++) {
            let s = arr[i].buy.toString()
            if (s.indexOf('.') > -1) {
              arr[i].buy = arr[i].buy.toFixed(1)
            }
          }
          this.tableData = arr
          this.isOk = true
        }
      )
    },
    handleExport () {
      util.toExcel(this.$refs.dataTable.columns, this.tableData, 'Book')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/library.vue